import { useSelector } from "react-redux";
import { CheckoutState } from "./slice";

export const useCheckoutState = () => {
    return useSelector((state: { checkout: CheckoutState }) => state.checkout);
};
